<template>
  <div v-if="isShow" class="radish-right" :style="{ 'z-index': zIndex }">
    <div class="radish-head">
      <div class="radish-title">CV导入</div>
      <div class="radish-btns"><el-button size="mini" icon="el-icon-close" circle @click="close"></el-button></div>
    </div>
    <div v-loading="loading" class="radish-body">
      <div class="radish-box" style="font-style:italic;padding:10px">
        <div>说明：</div>
        <ul>
          <li>支持格式：doc、docx、pdf，文件大小不能超过5M，一次上传文件个数不能超过20个；</li>
        </ul>
      </div>
      <div class="radish-box" style="padding:10px">
        <div>
          以下为非必填项，但填写会帮助您快速对人选分类：<br />如填写项与解析内容冲突，系统会默认以简历解析结果为主，可在解析后的人选界面手动调整：<br /><br />
        </div>
        <div v-if="extraReady">
          <template v-for="(f, fk) in fieldsExtra">
            <formItem
              :key="fk"
              :type="f.type"
              :is-inline="true"
              :width="f.width"
              :label="f.label"
              :options="f.options"
              :content="defaultData[fk]"
              :handle-data-change="handleItemChange"
            />
          </template>
        </div>
        <div>
          <formItem
            :type="fieldPro.type"
            :is-inline="true"
            :label="fieldPro.label"
            :options="fieldPro.options"
            :table-name="fieldPro.tableName"
            :field="fieldPro.field"
            :content="pid"
            :handle-data-change="handleProChange"
          />
        </div>
      </div>
      <div class="radish-box">
        <div v-show="uploadFiles.length == 0" class="radish-btns-superbig">
          <div class="radish-btn-superbig" @click="showUpload">选择单个CV文件</div>
          <div class="radish-btn-superbig" @click="showUploadMulti">选择多个CV文件</div>
        </div>
      </div>
      <!-- <el-button @click="tmp">测试</el-button> -->
      <div v-if="resData.length > 0" class="radish-box">
        <div>导入详情：</div>
        <div>共上传:{{ total }}份 成功:{{ successCount }}份 失败:{{ failCount }}份</div>
        <div>说明：</div>
        <div>
          1.成功的情况：<br />
          &nbsp;&nbsp;a.与单个人选重复，简历已经存为人选附件，点击进入对比查重；<br />
          &nbsp;&nbsp;b.与多个人选重复，点击选择要关联的人选；<br />
          &nbsp;&nbsp;c.无重复，已新建人选并存为附件，点击查看新建的人选；
        </div>
        <div>
          2.失败的情况：<br />
          &nbsp;&nbsp;a.文件类型或文件大小超出限制；<br />
          &nbsp;&nbsp;b.文件上传失败；<br />
          &nbsp;&nbsp;c.简历解析失败，点击手动搜索并关联人选；<br />
          &nbsp;&nbsp;d.简历解析后姓名为空，点击补充姓名；<br />
          &nbsp;&nbsp;e.简历解析后手机格式错误，点击修改手机；
        </div>
        <el-table border size="mini" :resizable="false" :data="resData" style="width: 100%">
          <el-table-column label="文件名" prop="filename"></el-table-column>
          <el-table-column label="状态" prop="status" width="70"></el-table-column>
          <el-table-column label="原因" prop="reasonMsg"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.reason === 'dupOne'"
                type="text"
                size="small"
                @click="popupCompareRadish(scope.row.rid, scope.row.file)"
                >对比重复人选</el-button
              >
              <el-button
                v-else-if="scope.row.reason === 'insertNew'"
                type="text"
                size="small"
                @click="showRadish(scope.row.rid)"
                >查看人选</el-button
              >
              <el-button
                v-else-if="scope.row.reason === 'noName'"
                type="text"
                size="small"
                @click="showSearchDialog(scope.row.filename, scope.row.file, scope.row.reason)"
                >添加姓名</el-button
              >
              <el-button
                v-else-if="scope.row.reason === 'phoneWrong'"
                type="text"
                size="small"
                @click="showSearchDialog(scope.row.filename, scope.row.file, scope.row.reason)"
                >修改手机</el-button
              >
              <el-button
                v-else-if="scope.row.reason === 'dupMulti'"
                type="text"
                size="small"
                @click="showChooseDialog(scope.row.rids)"
                >选择关联人选</el-button
              >
              <el-button
                v-else-if="scope.row.reason === 'parseFail'"
                type="text"
                size="small"
                @click="showSearchDialog(scope.row.filename, scope.row.file, scope.row.reason)"
              >
                添加关联人选
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <UploadDialog
      ref="UploadDialog"
      type="cv"
      :on-success="uploadSuccess"
      :on-error="uploadError"
      :on-exceed="uploadExceed"
      :before-upload="beforeUpload"
      title="上传单个CV"
      :limit="1"
    ></UploadDialog>
    <UploadDialog
      ref="UploadDialogMulti"
      type="cv"
      :on-success="uploadSuccessMulti"
      :on-error="uploadErrorMulti"
      :on-exceed="uploadExceedMulti"
      :before-upload="beforeUploadMulti"
      title="上传多个CV"
      :limit="20"
    ></UploadDialog>
    <SearchDialog ref="SearchDialog" :handle-search="handleSearch" :handle-reparse="handleReparse"></SearchDialog>
    <ChooseDialog ref="ChooseDialog" :handle-attach="handleAttach" :handle-create="handleCreate"></ChooseDialog>
    <FillDialog ref="FillDialog" :handle-fill="handleFill"></FillDialog>
    <RecommendCateDialog ref="rcdPopup" :handle-confirm="doPopupRadish" :has-tag-select="true"></RecommendCateDialog>
    <RecommendCateDialog ref="rcdPopupCompare" :handle-confirm="doPopupCompareRadish" :has-tag-select="true"></RecommendCateDialog>
  </div>
</template>
<script>
import { diYu } from './constant/common-var'
import { UploadDialog } from '../../file'
import ChooseDialog from './dialog/radish-choose-dialog'
import SearchDialog from './dialog/radish-search-dialog'
import RecommendCateDialog from './dialog/recommend-cate-dialog'
import FillDialog from './dialog/fill-phone-dialog.vue'

export default {
  components: { UploadDialog, ChooseDialog, SearchDialog, RecommendCateDialog, FillDialog },
  data: function() {
    return {
      zIndex: 1003,
      fieldsExtra: {
        长期意向: {
          label: '长期意向',
          width: '33%',
          type: 'select',
          options: {
            Y: 'Y.积极看机会',
            N: 'N.暂时不看机会',
            F: 'F.再跟进',
          },
        },
        行业: {
          label: '行业',
          width: '33%',
          type: 'select',
          options: app.industries || [],
          isRequired: true,
        },
        地域: {
          label: '地域',
          width: '33%',
          type: 'multSelect',
          options: diYu,
        },
        职能模块: {
          label: '职能模块',
          width: '33%',
          type: 'multSelect',
          options: [],
        },
        细分职能: {
          label: '细分职能',
          width: '33%',
          type: 'createSelect',
          options: [],
        },
        擅长方向: {
          label: '擅长方向',
          width: '33%',
          type: 'multSelect',
          options: [],
        },
        职级: {
          label: '职级',
          width: '33%',
          type: 'select',
          options: {
            '1': '1.高管',
            '2': '2.部门总',
            '3': '3.部门副总/总助/团队长',
            '4': '4.部门核心骨干',
            '5': '5.新人三年以下',
          },
        },
      },
      fieldPro: {
        label: '加入项目',
        type: 'select',
        options: [],
      },
      catData: [],
      defaultData: {},
      uploadFiles: [],
      currentFile: {},
      resData: [],
      searchData: {},
      total: 0,
      failCount: 0,
      successCount: 0,
      pid: '',
      isShow: false,
      loading: false,
      extraReady: true,
      from: '',
    }
  },
  created: function() {
    Promise.all([this.loadCate()])
  },
  methods: {
    async preview(file) {
      const ref = app.root.$refs.cvPreview
      if (!ref) return
      await ref.getFile(file)
      ref.show()
    },
    unique: function(arr) {
      return Array.from(new Set(arr))
    },
    handleItemChange: function(res) {
      const { label, content } = res
      if (label == '职能模块') {
        this.extraReady = false
        const currentCat = this.catData.filter(cat => content.includes(cat['名称']))
        if (currentCat.length > 0) {
          let znArr = []
          let scArr = []
          currentCat.forEach(cat => {
            if (cat['二级职能'] && cat['二级职能'].length > 0) {
              znArr = znArr.concat(cat['二级职能'])
            }
            if (cat['擅长方向'] && cat['擅长方向'].length > 0) {
              scArr = scArr.concat(cat['擅长方向'])
            }
          })
          this.fieldsExtra['细分职能'].options = this.unique(znArr)
          this.fieldsExtra['擅长方向'].options = this.unique(scArr)
        }
        this.extraReady = true
      }
      this.defaultData[label] = content
    },
    handleProChange: function(res) {
      const { label, content } = res
      this.pid = content
    },
    showUpload: function() {
      this.uploadFiles = []
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
    },
    showUploadMulti: function() {
      this.uploadFiles = []
      this.$refs.UploadDialogMulti && this.$refs.UploadDialogMulti.visible(true)
    },
    showRadish: function(id) {
      app.root.$refs.radishLeft.show(id)
    },

    beforeUpload: function(file) {
      const checkSupport = new RegExp('(.doc|.docx|.pdf)$')
      const isTypeRight = checkSupport.test(file.name)
      const isLt5M = file.size / 1024 / 1024 < 5
      let msg = ''
      if (!isTypeRight) {
        msg += '上传文件类型只能是word或pdf! '
      }
      if (!isLt5M) {
        msg += '上传文件大小不能超过5MB!'
      }
      if (!isTypeRight || !isLt5M) {
        this.$alert(msg, { showClose: false })
      }
      this.$refs.UploadDialog.visible()
      return isTypeRight && isLt5M
    },
    uploadSuccess: async function(response, file, fileList) {
      if (response.length > 0) {
        this.uploadFiles.push(response[0])
        this.$refs.UploadDialog.visible()
        // console.log(this.uploadFiles)
        await this.handleImport()
      }
    },
    // 测试
    // tmp() {
    //   this.uploadFiles = [
    //     {
    //       _id: 'ffe28afc64d397ff030c318895570b93',
    //       md5: 'ffe28afc64d397ff030c318895570b93',
    //       originalname: '田雨-中金公司-SE-B组-北京-阿尔法咨询-20180807.docx',
    //     },
    //     {
    //       _id: 'ffe60c0728269ddefd64de9a39425fdb',
    //       md5: 'ffe60c0728269ddefd64de9a39425fdb',
    //       originalname: '曾格凯茜-华安资产-信用研究岗-北京-阿尔法咨询-20180914.doc',
    //     },
    //   ]
    //   this.handleImportMulti()
    // },
    handleOne: async function(file) {
      this.loading = true
      try {
        const cvRes = await app.service('radish').cvHandleOne({
          doc: file,
          defaultFields: this.defaultData,
          pid: this.pid,
        })
        if (cvRes.status === 'success') {
          this.currentFile = cvRes.data.doc
          if (cvRes.data.rid) {
            await app.service('radish').modifyById({ _id: cvRes.data.rid, data: {长期意向:'Y'} })
            if (cvRes.msg === '重复') {
              // 与单个人重复
              this.popupCompareRadish(cvRes.data.rid, cvRes.data.doc || file)
            } else if (cvRes.msg === '新增cc') {
              // 无手机号
              this.preview({md5: cvRes.data.doc.md5})
              this.$refs.FillDialog.show(`简历${file.originalname}，未解析出手机号，请手动填写`, {
                name: cvRes.data.doc.data['姓名'],
                rid: cvRes.data.rid,
              })
            } else {
              // 新建的人选
              console.log('new')
              await this.popupRadish(cvRes.data.rid, cvRes.data.doc || file)
            }
          } else if (cvRes.data.rids && cvRes.data.rids.length > 0) {
            // 与多个人重复
            this.showChooseDialog(cvRes.data.rids)
          }
        } else {
          console.log('parse fail:', cvRes.msg)
          let reason = 'parseFail'
          if (cvRes.msg === '姓名为空') {
            reason = 'noName'
          } else if (cvRes.msg === '手机格式错误') {
            reason = 'phoneWrong'
          }
          this.showSearchDialog(file.originalname, cvRes.data.doc || file, reason)
        }
      } catch (error) {
        console.log('parse error:', error)
        this.showSearchDialog(file.originalname, file, 'parseFail')
      }
      this.loading = false
    },
    handleImport: async function() {
      if (this.uploadFiles.length === 1) {
        const file = this.uploadFiles[0]
        await this.handleOne(file)
      } else {
        this.$alert(`文件数量错误，限制选择1个文件，本次选择了${this.uploadFiles.length}个文件`, { showClose: false })
      }
    },
    // eslint-disable-next-line handle-callback-err
    uploadError: function(err, file, fileList) {
      this.$alert(`文件${file.name}上传失败`, { showClose: false })
      this.$refs.UploadDialog.visible()
    },
    uploadExceed: function(files, fileList) {
      this.$alert(`文件数量超出限制，限制最多选择1个文件，本次选择了${files.length}个文件`, { showClose: false })
      this.$refs.UploadDialog.visible()
    },

    beforeUploadMulti: function(file) {
      this.total++
      const checkSupport = new RegExp('(.doc|.docx|.pdf)$')
      const isTypeRight = checkSupport.test(file.name)
      const isLt5M = file.size / 1024 / 1024 < 5
      const item = { filename: file.name, status: '失败', reason: '', reasonMsg: '' }
      if (!isTypeRight) {
        item.reason = 'typeWrong'
        item.reasonMsg = '文件类型只能是word或pdf '
      }
      if (!isLt5M) {
        item.reason += 'tooBig'
        item.reasonMsg += '文件大小不能超过5MB'
      }
      if (!isTypeRight || !isLt5M) {
        this.resData.push(item)
        this.failCount++
        this.$refs.UploadDialogMulti.visible()
        return false
      }
      return true
    },
    uploadSuccessMulti: async function(response, file, fileList) {
      if (response.length > 0) {
        this.uploadFiles.push(response[0])
        if (this.uploadFiles.length === fileList.length) {
          this.$refs.UploadDialogMulti.visible()
          // console.log(this.uploadFiles)
          await this.handleImportMulti()
        }
      }
    },
    handleOneMulti: async function(file) {
      try {
        const { _id, originalname } = file
        const cvRes = await app.service('radish').cvHandleOne({
          doc: file,
          defaultFields: this.defaultData,
          pid: this.pid,
        })

        // let cvRes = { status: 'fail', msg: '失败' }
        // let cvRes = { status: 'fail', msg: '姓名为空', data: { doc: { data: { 手机: 13267547878 } } } }
        // let cvRes = { status: 'fail', msg: '手机格式错误', data: { doc: { data: { 姓名: '张三', 手机: 327857 } } } }

        // console.log(cvRes)
        if (cvRes.status === 'success') {
          if (cvRes.data.rid) {
            await app.service('radish').modifyById({ _id: cvRes.data.rid, data: {长期意向:'Y'} })
            if (cvRes.msg === '重复') {
              // 与单个人重复
              this.resData.push({
                filename: file.originalname,
                status: '成功',
                reason: 'dupOne',
                reasonMsg: '与单个人选重复，已存为该人选附件',
                file: cvRes.data.doc,
                rid: cvRes.data.rid,
              })
            } else {
              // 新建的人选
              this.resData.push({
                filename: file.originalname,
                status: '成功',
                reason: 'insertNew',
                reasonMsg: '无重复，已新建人选并存为附件',
                file: cvRes.data.doc,
                rid: cvRes.data.rid,
              })
            }
          } else if (cvRes.data.rids && cvRes.data.rids.length > 0) {
            // 与多个人重复
            this.resData.push({
              filename: file.originalname,
              status: '成功',
              reason: 'dupMulti',
              reasonMsg: '与多个人选重复',
              file: cvRes.data.doc,
              rids: cvRes.data.rids,
            })
          }
          this.successCount++
        } else {
          console.log('parse fail:', cvRes.msg)
          if (cvRes.msg === '姓名为空') {
            this.resData.push({
              filename: file.originalname,
              status: '失败',
              reason: 'noName',
              reasonMsg: '姓名为空',
              file: cvRes.data.doc || file,
            })
          } else if (cvRes.msg === '手机格式错误') {
            this.resData.push({
              filename: file.originalname,
              status: '失败',
              reason: 'phoneWrong',
              reasonMsg: '手机格式错误',
              file: cvRes.data.doc || file,
            })
          } else {
            this.resData.push({
              filename: file.originalname,
              status: '失败',
              reason: 'parseFail',
              reasonMsg: '解析失败',
              file: file,
            })
          }
          this.failCount++
        }
      } catch (e) {
        console.log('parse error:', e)
        this.resData.push({
          filename: file.originalname,
          status: '失败',
          reason: 'parseFail',
          reasonMsg: '解析出错',
          file: file,
        })
        this.failCount++
      }
    },
    handleImportMulti: function() {
      // this.loading = true
      if (this.uploadFiles.length > 0) {
        for (let i = 0; i < this.uploadFiles.length; i++) {
          const file = this.uploadFiles[i]
          this.handleOneMulti(file)
        }
      } else {
        this.$alert('请至少选择1个文件', { showClose: false })
      }
      // this.loading = false
    },
    uploadErrorMulti: function(err, file, fileList) {
      console.log('upload error:', err)
      this.resData.push({
        filename: file.name,
        status: '失败',
        reason: 'uploadFail',
        reasonMsg: '文件上传失败',
      })
      this.failCount++
      this.$refs.UploadDialogMulti.visible()
    },
    uploadExceedMulti: function(files, fileList) {
      this.$alert(`文件数量超出限制，限制最多选择20个文件，本次选择了${files.length}个文件`, { showClose: false })
      this.$refs.UploadDialogMulti.visible()
    },

    handleSearch: async function(radishes, { name, phone, country }) {
      this.searchData = {
        姓名: name,
        手机: phone,
        country,
      }
      if (radishes.length === 0) {
        this.handleCreate()
      } else if (radishes.length === 1 && phone) {
        this.handleAttach(radishes[0])
      } else {
        this.$refs.ChooseDialog.show(radishes)
      }
    },
    handleAttach: async function(row) {
      // console.log(row)
      const file = this.currentFile
      const aRes = await this.addAttach(file, row._id)
      if (aRes.status === 'success') {
        // 将选择或新建的人加入项目
        if (this.pid) {
          await app.service('radish').intoProject({ rid: row._id, pid: this.pid })
        }
        if (this.resData.length > 0) {
          this.resData = this.resData.map(dt => {
            if (this.currentFile.md5 === dt.file.md5) {
              dt.rid = row._id
              dt.status = '处理完毕'
              dt.reasonMsg = '成功关联人选'
              dt.reason = 'dupOne'
            }
            return dt
          })
        }
        this.popupCompareRadish(row._id, file)
        return true
      } else {
        this.$alert('挂载简历失败', { showClose: false })
        return false
      }
    },
    addAttach: async function(file, rid) {
      const dt = {
        fileId: file._id,
        uploader: file.uploader,
        originalname: file.originalname,
        src: file.src,
        md5: file.md5,
        type: '原始简历',
        rid: rid,
      }
      return await app.service('radish').addAttachment(dt)
    },
    handleCreate: async function() {
      const dt = JSON.parse(JSON.stringify(this.searchData))
      if (this.currentFile.data) {
        Object.keys(this.currentFile.data).forEach(key => {
          const val = this.currentFile.data[key]
          if (val) {
            if (
              (key !== '姓名' && key !== '手机') ||
              (key === '姓名' && !dt['姓名']) ||
              (key === '手机' && !dt['手机'])
            ) {
              dt[key] = val
            }
          }
        })
      }
      const insertRes = await app.service('cv').cvInsert(dt)
      if (insertRes.status === 'success') {
        this.handleAttach({ _id: insertRes.data.rid })
        if (this.resData.length > 0) {
          this.resData = this.resData.map(dt => {
            if (this.currentFile.md5 === dt.file.md5) {
              dt.rid = insertRes.data.rid
              dt.status = '处理完毕'
              dt.reasonMsg = '成功新建人选'
              dt.reason = 'insertNew'
            }
            return dt
          })
        }
      } else {
        console.log('insert error:', insertRes.msg)
        this.$alert('新建人选失败', { showClose: false })
      }
    },
    handleFill(rid) {
      this.$message.success('操作成功')
      this.close()
      window.open(`${window.frontend}/#/radish-detail-blank/${rid}`, '_blank')
    },
    async popupRadish(rid, file) {
      // if (this.from === 'radishAdd') {
      //   app.root.$refs.radishAdd.$refs.rcdPopup.show(rid, file)
      //   this.close()
      // } else {
      this.$refs.rcdPopup.show(rid, file)
      // }
    },
    doPopupRadish: async function(rid, file) {
      await app.root.$refs.radishDetailTab.addTab({ id: rid })
      app.root.$refs.radishLeft.close()
      this.preview(file)
      this.close()
    },
    popupCompareRadish(rid, file) {
      this.$refs.rcdPopupCompare.show(rid, file)
    },
    doPopupCompareRadish: async function(rid, file) {
      await app.root.$refs.radishDetailTab.addTab({ id: rid })
      app.root.$refs.radishDetailTab.$refs[rid][0].currentParseMd5 = file.md5
      app.root.$refs.radishDetailTab.$refs[rid][0].parseCv()
      app.root.$refs.radishLeft.close()
      if (this.uploadFiles.length === 1) {
        this.close()
      }
    },
    showChooseDialog: async function(rids) {
      const radishes = await app.service('radish').simpleList({
        query: { _id: { $in: rids } },
        fields: { 姓名: 1, 手机: 1, 公司: 1, 部门: 1, 职能模块: 1 },
      })
      if (radishes.data && radishes.data.length > 0) {
        this.$refs.ChooseDialog.show(radishes.data)
      } else {
        this.$refs.SearchDialog.show('请手动填写手机或姓名')
      }
    },
    showSearchDialog: function(originalname, doc, reason, rid) {
      this.currentFile = doc
      this.preview({md5: doc.md5})
      if (doc.data && reason === 'noName') {
        this.$refs.SearchDialog.show(`简历${originalname}已经作为文件上传，但解析姓名为空，请手动填写`, {
          phone: doc.data['手机'],
        })
      } else if (doc.data && reason === 'phoneWrong') {
        this.$refs.SearchDialog.show(`简历${originalname}已经作为文件上传，但手机格式错误，请修改`, {
          name: doc.data['姓名'],
          phone: doc.data['手机'],
        })
      } else {
        this.$refs.SearchDialog.show(
          `简历${originalname}已经作为文件上传，但解析失败，请手动输入人选姓名、手机（必填其一）`,
        )
      }
    },
    handleReparse: function() {
      if (this.resData.length > 0) {
        this.resData = this.resData.filter(dt => dt.file.md5 != this.currentFile.md5)
        this.handleOneMulti(this.currentFile)
      } else {
        this.handleOne(this.currentFile)
      }
    },

    removeRow: function(index) {
      this.resData.splice(index, 1)
      this.$message.success({ duration: 500, message: '操作成功' })
    },
    loadCate: async function() {
      if (!app.categories) {
        await app.getCats()
      }
      this.catData = app.categories
      if (this.catData && this.catData.length > 0) {
        this.fieldsExtra['职能模块'].options = this.catData.map(item => item['名称'])
      }
    },
    loadPro: async function() {
      if (!app.projects) {
        await app.getProjects()
      }
      const proData = app.projects
      if (proData && proData.length > 0) {
        const opts = {}
        proData.forEach(item => {
          const v = `${item['项目名称']}(${item['客户公司']})`
          opts[item._id] = v
        })
        this.fieldPro.options = opts
      }
    },
    open: function(opts) {
      this.reset(opts)
      this.loadPro()
      this.zIndex = app.root.dragindex++
      this.isShow = true
    },
    close: function() {
      this.isShow = false
    },
    reset: function(opts) {
      this.defaultData = {}
      this.uploadFiles = []
      this.resData = []
      this.total = 0
      this.failCount = 0
      this.successCount = 0
      this.pid = ''
      if (opts && opts.from) {
        this.from = opts.from
      }
      if (opts && opts.defaultPid) {
        this.pid = opts.defaultPid
      } else {
        this.pid = ''
      }
    },
  },
}
</script>
